import { IMessagesParams } from './types';

export const messagesKeys = {
  all: () => ['MESSAGES'] as const,
  messages: (params: IMessagesParams) => ['MESSAGES', params],
};
